import { useContext, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { ClipLoader } from 'react-spinners';
import { AppInfoContext } from '../../../../../../App';
import './DeleteWorkOrder.css';

export default function DeleteWorkOrder({ setFormStep, closeModal }) {
  const { appInformation } = useContext(AppInfoContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleted, setIsDeleted] = useState({
    completed: false,
    success: false,
  });
  const token = localStorage.getItem('token');

  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const reloadData = () => {
    const currentZoom = window.map.getView().getZoom();
    window.map.getView().setZoom(currentZoom + 0.0001);
  };

  reloadData();
  const { mutate: deleteWorkOrderMutate } = useMutation({
    mutationFn: () =>
      fetch(
        `${apiUrl}/work-orders/${appInformation.problemManagement.workOrderId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      ),

    onSuccess: (response) => {
      if (response.status === 204) {
        setIsDeleted({ completed: true, success: true });
        setIsLoading(false);
        reloadData();
        window.popup.hide();
        return;
      }
      setIsDeleted({ completed: true, success: false });
      setIsLoading(false);
      window.popup.hide();
    },
    onError: (error) => {
      setIsDeleted({ completed: true, success: false });
      console.log('error', error);
      setIsLoading(false);
      window.popup.hide();
    },
  });

  const handleWorkOrderDeletion = () => {
    deleteWorkOrderMutate();
    setIsLoading(true);
  };

  return (
    <>
      {isLoading && (
        <div className="delete-work-order-spinner">
          <ClipLoader
            color={'gray'}
            loading={isLoading}
            size={60}
            data-testid="loader"
          />
        </div>
      )}

      {!isLoading && (
        <div className="delete-work-order-container">
          {!isDeleted.completed && (
            <div className="delete-work-order-body">
              <h3 className="delete-work-order-confirmation-message">
                Da li ste sigurni da želite poništiti radni nalog?
              </h3>
              <div className="delete-work-order-buttons">
                <button
                  className="delete-wo-back-button"
                  onClick={() => setFormStep(3)}
                >
                  Nazad
                </button>
                <button
                  className="delete-wo-confirm-button"
                  onClick={handleWorkOrderDeletion}
                >
                  Poništi
                </button>
              </div>
            </div>
          )}

          {isDeleted.completed && (
            <div>
              <h3 className="delete-work-order-confirmation-message">
                {isDeleted.success
                  ? 'Radni nalog je uspješno poništen.'
                  : 'Trenutno nije moguće poništiti radni nalog.'}
              </h3>
              <button
                type="submit"
                className="pl-close-button"
                onClick={closeModal}
              >
                Zatvori
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
}
